<template>

	<!-- Countdown Timer-->
	<div id="countdown-timer">
		<span data-countdown="campaign.end_date">
			<ul :id="`countdown-${makeSlug(campaign.name)}`" class="countdown mb-0">
				<li>
					<span class="days">00</span>
					<div class="countdown-text days_text">
					{{ $t('donation-form.days') }}
					</div>
				</li>
				<li>
					<span class="hours">00</span>
					<div class="countdown-text hours_text">
					{{ $t('donation-form.hours') }}
					</div>
				</li>
				<li>
					<span class="minutes">00</span>
					<div class="countdown-text minutes_text">
					{{ $t('donation-form.minutes') }}
					</div>
				</li>
				<li>
					<span class="seconds">00</span>
					<div class="countdown-text seconds_text">
					{{ $t('donation-form.seconds') }}
					</div>
				</li>
			</ul>
		</span>
	</div>
</template>

<!-- Scripts -->
<script setup>
import {onMounted} from "vue";
import useHelpers from "@/Composables/UseHelpers";

require('@/../vendor/jquery-countdown/jquery.countdown.min');

const { makeSlug, $t } = useHelpers();

const props = defineProps({
	campaign: Object
});

onMounted(() => {
	if (props.campaign.countdown_enabled) {
		$(`#countdown-${makeSlug(props.campaign.name)}`).countdown({
			date: props.campaign.end_date ?? new Date().toISOString().slice(0, 10),
			day: $t('donation-form.day'),
			days: $t('donation-form.days'),
			hour: $t('donation-form.hour'),
			hours: $t('donation-form.hours'),
			minute: $t('donation-form.minute'),
			minutes: $t('donation-form.minutes'),
			second: $t('donation-form.second'),
			seconds: $t('donation-form.seconds'),
		});
	}
});
</script>
